import { makeAddValueToLinkState } from "seneca-common/utils/routing";

import { linkToDashboard } from "features/dashboard/links";
import { SUBSCRIPTION_JOURNEY_SOURCES } from "features/subscriptions/analytics/consts";
import { Options as SubscriptionLinkOptions } from "features/subscriptions/features/what-is-premium";

// Use this when routing users to the what is premium page
export function makeLinkToWhatIsPremium(options: SubscriptionLinkOptions) {
  return makeAddValueToLinkState(options)(linkToStudentWhatIsPremiumPage());
}

// Only use this inside the routing structure
export function linkToStudentWhatIsPremiumPage() {
  return `${linkToDashboard()}/what-is-premium`;
}

export { SUBSCRIPTION_JOURNEY_SOURCES };
